/**
 * NullObject プラットフォームアダプタ (NullPlatformBridgeAdapter)
 * Web無料版やスマホ版など、常駐モード非対応環境向けの安全なスタブ
 */

import type { DisplayWorkArea, IPlatformBridgeAdapter, WindowBounds } from './IPlatformBridgeAdapter';

export class NullPlatformBridgeAdapter implements IPlatformBridgeAdapter {
  public isSupported(): boolean {
    return false;
  }

  public async setAlwaysOnTop(_enable: boolean): Promise<void> {
    // 非対応環境のため何もしない (エラーなし)
  }

  public async setClickThrough(_enable: boolean): Promise<void> {
    // 非対応環境のため何もしない (エラーなし)
  }

  public async getBounds(): Promise<WindowBounds> {
    return { x: 0, y: 0, width: 320, height: 320 };
  }

  public async setBounds(_bounds: Partial<WindowBounds>): Promise<void> {
    // 非対応環境のため何もしない (エラーなし)
  }

  public async getWorkArea(): Promise<DisplayWorkArea> {
    return { x: 0, y: 0, width: 1920, height: 1080 };
  }
}
